import React, { useState } from "react";
import "./component.css";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import Sidebar from "../../Navigation/Sidebar/Sidebar";

import {
  TextField,
  Checkbox,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import uploadImage from "../../../assests/uploadImage.svg";
import RemoveIcon from "@mui/icons-material/Remove";
import CancelIcon from "@mui/icons-material/Cancel";
import Modal from "react-bootstrap/Modal";

import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
const ComboCreateComponent = (props) => {
  const {
    name,
    description,
    retail_price,
    offer_price,
    startDate,
    endDate,
    file,
    applyOnKiosk,
    applyOnConsumerApp,
    mvConfig,
    setName,
    setDescription,
    setretail_price,
    setoffer_price,
    setStartDate,
    setEndDate,
    setFile,
    setApplyOnKiosk,
    setApplyOnConsumerApp,
    handleAddMvId,
    handleQuantityChange,
    handleCreateComboApi,
    filePreview,
  } = props;

  const navigate = useNavigate();

  const handleClick = () => navigate(-1);

  const setPrice = (newPrice, itemId) => {
    
    const updatedItems = props&&props.selectedMvItems.map((item) =>
      item.id === itemId ? { ...item, price: newPrice } : item
    );
 
    props.setSelectedMvItems(updatedItems);
  };
  

  return (
    <div className="main-div" style={{ margin: "auto" }}>
      <Sidebar />

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create Combo
          </h2>
        </div>

        <div
          style={{
            margin: "20px",
            overflowY: "auto",
            height: "92vh",
            width: "80vw",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            alignContent: "center",
            borderRadius: "14px",
          }}
        >
          <div style={{ height: "100vh" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <div style={{ width: "27vw", margin: "auto", padding: "40px" }}>
                <TextField
                  label="Name"
                  autoComplete="off"
                  fullWidth
                  variant="standard"
                  margin="normal"
                  value={props.name}
                  onChange={(e) => props.setName(e.target.value)}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />
                {props.errors && props.errors.name && (
                  <span className="errortext">
                    {props.errors && props.errors.name}
                  </span>
                )}

                <TextField
                  label="Description"
                  variant="standard"
                  fullWidth
                  margin="normal"
                  value={props.description}
                  onChange={(e) => props.setDescription(e.target.value)}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />
                {props.errors && props.errors.description && (
                  <span className="errortext">
                    {props.errors && props.errors.description}
                  </span>
                )}

                <TextField
                  label="MRP"
                  variant="standard"
                  fullWidth
                  margin="normal"
                  inputProps={{ maxLength: 6 }}
                  type="number"
                  value={props.retail_price}
                  onChange={(e) => props.setretail_price(e.target.value)}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />
                {props.errors && props.errors.offer_price && (
                  <span className="errortext">
                    {props.errors && props.errors.offer_price}
                  </span>
                )}
                <TextField
                  label="Selling price"
                  variant="standard"
                  fullWidth
                  type="number"
                  margin="normal"
                  inputProps={{ maxLength: 6 }}
                  value={props.offer_price}
                  onChange={(e) => props.setoffer_price(e.target.value)}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />
                {props.errors && props.errors.retail_price && (
                  <span className="errortext">
                    {props.errors && props.errors.retail_price}
                  </span>
                )}

                <div
                  style={{ display: "flex", gap: "10px", marginBottom: "20px" }}
                >
                  <DateTimePicker
                    label="Starting Date"
                    value={props.startDate}
                    onChange={(date) => props.setStartDate(date)}
                    minDate={new Date()}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        sx={{
                          "& .MuiInput-underline:before": {
                            borderBottomColor: "#14AE78",
                          },
                          "& .MuiInput-underline:after": {
                            borderBottomColor: "#14AE78",
                          },
                        }}
                      />
                    )}
                  />
                  {props.errors && props.errors.startDate && (
                    <span className="errortext">
                      {props.errors && props.errors.startDate}
                    </span>
                  )}
                  TO
                  <DateTimePicker
                    label="Expire Date"
                    value={props.endDate}
                    onChange={(date) => props.setEndDate(date)}
                    minDate={props.startDate || new Date()}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        sx={{
                          "& .MuiInput-underline:before": {
                            borderBottomColor: "#14AE78",
                          },
                          "& .MuiInput-underline:after": {
                            borderBottomColor: "#14AE78",
                          },
                        }}
                      />
                    )}
                  />
                </div>
                {props.errors && props.errors.date && (
                  <span className="errortext">
                    {props.errors && props.errors.date}
                  </span>
                )}

                <div
                  style={{
                    marginBottom: "20px",
                    display: "flex",
                    width: "23vw",
                  }}
                >
                  <p>Image</p>
                  {!props.selectedFile ? (
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      style={{
                        borderStyle: "dashed",
                        color: "#14AE78",
                        borderColor: "#14AE78",
                        backgroundColor: "#63E2B61C",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "30px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <img src={uploadImage} alt="Upload icon" />
                        <p style={{ fontWeight: 600, color: "#14AE78" }}>
                          Choose file or drag here
                        </p>
                      </div>
                      <input
                        type="file"
                        hidden
                        onChange={props.handleFileChange}
                      />
                    </Button>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "12vw",
                        height: "12vh",
                        marginTop: "20px",
                      }}
                    >
                      <img
                        src={props.imagePreview}
                        alt="Selected file preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "10px",
                          padding: "5px",
                          objectFit: "cover",
                        }}
                      />
                      <IconButton
                        onClick={props.handleRemoveFile}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "-25px",
                          border: "1px solid #111111",
                          padding: "2px",
                        }}
                      >
                        <CancelIcon
                          fontSize="small"
                          style={{ color: "#111111" }}
                        />
                      </IconButton>
                    </div>
                  )}
                </div>

                <Button
                  onClick={props.handleImageUpload}
                  variant="outlined"
                  color="success"
                >
                  upload image
                </Button>
                {props.errors && props.errors.file && (
                  <span className="errortext">
                    {props.errors && props.errors.file}
                  </span>
                )}

                <div style={{ marginBottom: "20px" }}>
                  <p style={{ marginTop: "10px" }}>Apply on</p>
                  <div>
                    <Checkbox
                      style={{ color: "#14AE78" }}
                      checked={props.applyOnKiosk}
                      onChange={(e) => props.setApplyOnKiosk(e.target.checked)}
                    />
                    Kiosk
                    <Checkbox
                      style={{ color: "#14AE78" }}
                      checked={props.applyOnConsumerApp}
                      onChange={(e) =>
                        props.setApplyOnConsumerApp(e.target.checked)
                      }
                    />
                    Consumer App
                  </div>
                  {props.errors && props.errors.selection && (
                    <span className="errortext">
                      {props.errors && props.errors.selection}
                    </span>
                  )}
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <div style={{ display: "flex" }}>
                    <TextField
                      label="Click to add MV ID"
                      fullWidth
                      disabled="true"
                      value={props.mvId}
                      onChange={(e) => props.setMvId(e.target.value)}
                      style={{ marginBottom: "10px", color: "#ccc" }}
                      variant="standard"
                      sx={{
                        "& .MuiInput-underline:before": {
                          borderBottomColor: "#14AE78",
                        },
                        "& .MuiInput-underline:after": {
                          borderBottomColor: "#14AE78",
                        },
                      }}
                    />

                    <Button
                      onClick={props.handleOpenModal}
                      style={{
                        marginBottom: "14px",
                        marginLeft: "-60px",
                        backgroundColor: "#14AE78",
                        color: "#fff",
                      }}
                      disabled={!props && props.mvId.trim()}
                    >
                      Add
                    </Button>
                  </div>
                  {props.errors && props.errors.mvConfig && (
                    <span className="errortext">
                      {props.errors && props.errors.mvConfig}
                    </span>
                  )}

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {props.selectedMvItems.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          padding: "5px",
                          marginTop: "10px",
                          border: "1px solid #ccc",
                          justifyContent: "space-between",
                        }}
                      >
                        <span
                          style={{ color: "#000000" }}
                        >{`ID: ${item.id}`}</span>
                        {/* <span
                          style={{ color: "#000000" }}
                        >{`Price: ${item.offer_price}`}</span> */}
                        <TextField
                          label=" Selling Price"
                          variant="standard"
                          fullWidth
                          margin="normal"
                          type="number"
                          maxLength="6"
                          value={item.price || ""}
                          onChange={(e) => setPrice(e.target.value, item.id)}
                          sx={{
                            "& .MuiInput-underline:before": {
                              borderBottomColor: "#14AE78",
                            },
                            "& .MuiInput-underline:after": {
                              borderBottomColor: "#14AE78",
                            },
                            width: "8vw",
                          }}
                        />

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            backgroundColor: "#14AE78",
                            borderRadius: "5px",
                          }}
                        >
                          <IconButton
                            onClick={() => props.decrementQuantity(item.id)}
                            style={{ color: "#fff" }}
                          >
                            <RemoveIcon />
                          </IconButton>
                          <span style={{ color: "#fff" }}>{item.quantity}</span>
                          <IconButton
                            onClick={() => props.incrementQuantity(item.id)}
                            style={{ color: "#fff" }}
                          >
                            <AddIcon />
                          </IconButton>
                        </div>
                      </div>
                    ))}
                  </div>
                  <Dialog
                    open={props.modalOpen}
                    onClose={props.handleCloseModal}
                    maxWidth="md"
                    PaperProps={{
                      style: {
                        height: "80vh",
                        width: "70vw",
                      },
                    }}
                  >
                    <Typography
                      style={{
                        marginLeft: "30px",
                        color: "black",
                        fontWeight: 600,
                        fontSize: "18px",
                      }}
                    >
                      Select an MV ID
                    </Typography>

                    <DialogContent>
                      <TextField
                        label="Search MV ID"
                        fullWidth
                        type="number"
                        autoComplete="off"
                        value={props.searchQuery}
                        onChange={props.handleSearchQueryChange}
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "30vw" }}
                      />

                      <div
                        style={{ maxHeight: "60vh", overflowY: "auto" }}
                        ref={props.tableContainerRef}
                      >
                        <Table style={{ width: "100%" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ textAlign: "center" }}>
                                Select
                              </TableCell>
                              <TableCell style={{ textAlign: "center" }}>
                                ID
                              </TableCell>
                              <TableCell style={{ textAlign: "center" }}>
                                Product Name
                              </TableCell>
                              <TableCell style={{ textAlign: "center" }}>
                                Price
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {props.filteredMvList &&
                              props.filteredMvList.map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell style={{ textAlign: "center" }}>
                                    <Radio
                                      checked={
                                        props.selectedMvItem?.id === item.id
                                      }
                                      onChange={() =>
                                        props.handleSelectMvId(item)
                                      }
                                      value={item.id}
                                    />
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {item.id}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {item.variant_name}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {item.offer_price}
                                  </TableCell>
                                </TableRow>
                              ))}
                            {props.isLoading && (
                              <Typography
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                  color: "gray",
                                }}
                              >
                                Loading...
                              </Typography>
                            )}
                          </TableBody>
                        </Table>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>

                <Modal
                  show={props.successModalOpen}
                  onHide={props.handleCloseSuccessModal}
                >
                  <Modal.Body>
                    <h4>Combo Created Successfully</h4>
                    <p>Your combo has been created!</p>
                    <button onClick={props.handleCloseSuccessModal}>OK</button>
                  </Modal.Body>
                </Modal>
              </div>
            </LocalizationProvider>
          </div>
        </div>
        <div
          style={{
            position: "fixed",
            margin: "auto",
            bottom: "10px",
            width: "6vw",
            left: "52%",
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            padding: "10px",
            borderRadius: "10px",
            // boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <Button
            style={{ backgroundColor: "#14AE78", color: "#fff", width: "100%" }}
            onClick={props.submitApiButton}
            open={props.successModalOpen}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ComboCreateComponent;
